import classNames from 'classnames';
import React, { ReactNode } from 'react';
import './MessageBox.scss';

const baseClassName = `message-box`;

type MessageBoxProps = {
    type: 'error' | 'warning';
    content: string | ReactNode;
};

export const MessageBox = ({ type, content }: MessageBoxProps) => {

    if (!content) return null;

    return (
        <div className={classNames(baseClassName, {
            [`${baseClassName}--with-type`]: type,
            [`${baseClassName}--${type}`]: type,
        })}>
            <div className={`${baseClassName}__content`}>{content}</div>
        </div>
    );
}

export default MessageBox;
